import React, { useRef } from 'react';
import Slider from 'react-slick';
import { useHomePage } from './talons/useHomePage';
import cardImg from './assests/card.png';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosArrowForward } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { Button } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import { AdaptableCard } from 'components/shared';
import { GET_DOCTORS } from 'views/website/HomePage/talons/homePage.gql';

const Doctors = () => {
  const navigate = useNavigate();
  const { specialties } = useHomePage();
  let sliderRef = useRef(null);

  const { data, error, loading } = useQuery(GET_DOCTORS);
  const doctors = data?.doctors?.map((doctor) => ({ ...doctor.user, id: doctor.id }));

  console.log({ doctors });

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="bg-[#B9CAC8] w-full flex justify-center">
      <div className="lg:max-w-screen-2xl lg:py-28 p-4 w-full">
        <div className="mb-8">
          <h1 className="w-full text-teal-800 font-bold mb-2 font-sans lg:text5xl text-3xl">
            Confira o nosso time de dermatologistas
          </h1>
        </div>

        <div>
          <Slider {...settings}>
            {doctors?.map((doctor) => (
              <div className="p-1">
                <div className="flex flex-col justify-center items-center rounded-lg overflow-hidden">
                  <img
                    src={doctor.image_url}
                    alt="card header"
                    className="w-full h-[400px] object-cover bg-white rounded-lg"
                  />
                  <Button
                    size="md"
                    variant="solid"
                    onClick={() => navigate(`/appointment/${doctor.id}/Sem escolha`)}
                    className="bottom-[60px] relative z-3 flex items-center justify-center gap-2 shadow shadow-inner"
                  >
                    <IoSearch size={15} color={'white'} />
                    <p className="text-xs font-bold">Agendar sua consulta</p>
                  </Button>
                </div>

                <div className="mt-[-30px]">
                  <h5 className="font-bold text-teal-800 text-center">
                    Dr. {doctor.firstname} {doctor.lastname}
                  </h5>
                  <h6 className="text-center">
                    {doctor.city}, {doctor.region}
                  </h6>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Doctors;
